import React from "react";
import BankingMain from "../../../../Components/Banking/BankingMain";

const Banking_Dashboard = () => {
  return <BankingMain />;
};

export default Banking_Dashboard;
